import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { ArrowRight } from '@/components/Icons'

export const standaloneCtaBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current

  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground
    ? `#${umbraco.BlockBackground}`
    : '#ffffff'

  const primary = umbraco.PrimaryButton
  const secondary = umbraco.SecondaryButton
  const tertiary = umbraco.TertiaryButton
  const hyperlink = umbraco.ButtonHyperlink

  const buttons = []

  // Primary
  if (primary) {
    buttons.push({
      ...primary,
      variant: 'primary',
      size: 'lg'
    })
  }

  // Secondary preferred over tertiary
  if (secondary) {
    buttons.push({
      ...secondary,
      variant: 'secondary',
      size: 'lg'
    })
  } else if (tertiary) {
    buttons.push({
      ...tertiary,
      variant: 'primary-alt',
      size: 'lg'
    })
  }

  // Hyperlink only if nothing else exists
  else if (hyperlink) {
    buttons.push({
      ...hyperlink,
      variant: 'link'
    })
  }

  return (
    <div
      data-theme={theme}
      className='relative isolate text-[--theme-text]'
      style={{ backgroundColor }}
    >
      {/* Set to use green gradient by default and dark radial gradient if set to dark theme. The default green gradient should not show if a background colour is selected */}
      <div aria-hidden='true' className={`absolute inset-0 -z-10 transform-gpu overflow-hidden ${theme === 'dark' ? 'bg-default-800' : ''} ${theme === 'light' && umbraco.BlockBackground === '' ? 'bg-green-1' : ''}`}>
        {theme === 'dark' &&
          <div className='absolute border-radius-[800px] left-1/2 -bottom-[540px] md:-bottom-[480px] lg:-bottom-[440px] w-[1000px] h-[800px] bg-blue-rad -translate-x-1/2 blur-2xl' />}
      </div>
      <div className='mx-auto w-full max-w-xl xl:max-w-7xl'>
        <div className='_block-section _standaloneCtaBlock-section px-4 py-10 sm:px-6 lg:px-8'>

          <div className='flex md:flex-row flex-wrap items-center justify-center gap-y-2.5 gap-x-6'>

            {buttons.map((btn, index) => (
              <Button
                key={index}
                href={btn.Url}
                target={btn.Target}
                variant={btn.variant}
                size={btn.size}
                componentName={
                                    btn.Url?.includes('#apply-dialog')
                                      ? 'Standalone CTA Block'
                                      : null
                                }
              >
                {btn.variant === 'primary-alt'
                  ? (
                    <span className='block relative pr-7'>{btn.Name} <ArrowRight className='absolute -right-0.5 top-1/2 -mt-[11px]' /></span>
                    )
                  : (
                      btn.Name
                    )}
              </Button>
            ))}

          </div>

        </div>
      </div>
    </div>
  )
}

export const StandaloneCtaBlock = standaloneCtaBlock

reactMount('standaloneCtaBlock', standaloneCtaBlock)
